import React, { useState, useEffect } from 'react';
import api from './api';

const FactoryMaster = () => {
    const [factories, setFactories] = useState([]);
    const [form, setForm] = useState({ 
        name: '', companyName: '', mobile: '', 
        address: '', gstNumber: ''
    });

    const fetchFactories = async () => {
        try {
            const res = await api.get('/factories');
            setFactories(res.data);
        } catch (err) { console.error("Error loading factories"); }
    };

    useEffect(() => { fetchFactories(); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/factories', form);
            alert("✅ Factory Added!");
            setForm({ name: '', companyName: '', mobile: '', address: '', gstNumber: '' });
            fetchFactories();
        } catch (err) { alert("Error adding factory"); }
    };

    return (
        <div className="container mt-4">
            <h4>🏭 MFG Party Master (Factories)</h4>
            
            {/* ADD FORM */}
            <div className="card p-3 mb-4 bg-light shadow-sm">
                <form onSubmit={handleSubmit}>
                    <div className="row g-2">
                        <div className="col-md-3">
                            <label className="small fw-bold">Company / Factory Name</label>
                            <input className="form-control" value={form.companyName} onChange={e => setForm({...form, companyName: e.target.value})} required />
                        </div>
                        <div className="col-md-3">
                            <label className="small fw-bold">Contact Person</label>
                            <input className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                        </div>
                        <div className="col-md-2">
                            <label className="small fw-bold">Mobile</label>
                            <input className="form-control" value={form.mobile} onChange={e => setForm({...form, mobile: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label className="small fw-bold">GSTIN</label>
                            <input className="form-control" value={form.gstNumber} onChange={e => setForm({...form, gstNumber: e.target.value})} />
                        </div>
                        <div className="col-md-2 align-self-end">
                            <button className="btn btn-primary w-100">Save</button>
                        </div>
                        <div className="col-12 mt-2">
                            <label className="small fw-bold">Full Address (For Jangad Print)</label>
                            <input className="form-control" value={form.address} onChange={e => setForm({...form, address: e.target.value})} placeholder="Building, Area, City..." />
                        </div>
                    </div>
                </form>
            </div>

            {/* LIST */}
            <div className="card shadow-sm">
                <table className="table table-hover mb-0 align-middle">
                    <thead className="table-dark">
                        <tr><th>Factory Name</th><th>Person</th><th>Mobile</th><th>Address</th><th>GST</th></tr>
                    </thead>
                    <tbody>
                        {factories.length === 0 ? <tr><td colSpan="5" className="text-center p-3">No Factories Added</td></tr> :
                        factories.map(f => (
                            <tr key={f._id}>
                                <td className="fw-bold">{f.companyName}</td>
                                <td>{f.name}</td>
                                <td>{f.mobile}</td>
                                <td className="small text-muted">{f.address}</td>
                                <td>{f.gstNumber}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default FactoryMaster;